import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import styled from "styled-components";

export const Overlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9998;
  cursor: pointer;
  pointer-events: all;
`;

export const MenuContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 20rem;
  max-width: 90vw;
  background: ${({ theme }) => theme.palette.neutral.darkest};
  border-left: 1px solid ${({ theme }) => theme.palette.neutral.medium};
  box-shadow: -4px 0 15px rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: auto;
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;


export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.medium};

  .logo {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  h2 {
    font-weight: 700;
    color: ${({ theme }) => theme.palette.neutral.lightest};
  }

  button {
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.palette.neutral.lightest};
    cursor: pointer;
    border-radius: 50%;
    padding: 0.5rem;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.palette.neutral.lightest};
  width: 1.5rem;
  height: 1.5rem;
`;

export const Nav = styled.nav`
  padding: 1rem;

  h3 {
    text-transform: uppercase;
    font-size: 0.75rem;
    color: ${({ theme }) => theme.palette.neutral.medium};
    margin-bottom: 0.75rem;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      gap: 1rem;
      border-radius: 1rem;
      color: ${({ theme }) => theme.palette.neutral.lightest};
      transition: background 0.2s ease;

      a:hover {
        background: ${({ theme }) => theme.palette.primary.dark};
      }
    }
  }
`;

export const Footer = styled.div`
  padding: 1rem 0;
  border-top: 1px solid ${({ theme }) => theme.palette.neutral.medium};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  a {
    text-align: center;
    padding: 0.75rem;
    border-radius: 1rem;
    text-decoration: none;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.neutral.lightest};
    transition: all 0.2s ease;

    &.primary {
      background: ${({ theme }) => theme.palette.primary.medium};
      color: white;
      align-items: center;
      &:hover {
        background: ${({ theme }) => theme.palette.primary.light};
      }
    }

    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }
`;
